import { NgClass } from '@angular/common';
import { Component, Injectable, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

export interface ConfirmOptions {
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  /** Acción destructiva: el botón de confirmar va en rojo. */
  danger?: boolean;
}

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  template: `
    <div class="modal-header border-0 pb-0">
      <h5 class="modal-title fw-bold">
        <i class="fa-solid me-2" [ngClass]="opts.danger ? 'fa-triangle-exclamation text-danger' : 'fa-circle-question text-primary'"></i>{{ opts.title || 'Confirmar' }}
      </h5>
      <button type="button" class="btn-close" aria-label="Cerrar" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body pt-2">{{ opts.message }}</div>
    <div class="modal-footer border-0 pt-0">
      <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">{{ opts.cancelLabel || 'Cancelar' }}</button>
      <button type="button" class="btn" [ngClass]="opts.danger ? 'btn-danger' : 'btn-primary'" (click)="modal.close(true)" ngbAutofocus>{{ opts.confirmLabel || 'Aceptar' }}</button>
    </div>
  `,
  imports: [NgClass],
})
export class ConfirmDialogComponent {
  @Input() opts: ConfirmOptions = { message: '' };
  constructor(public modal: NgbActiveModal) {}
}

/** Reemplaza a `confirm()` del navegador: pide confirmación en un modal de la aplicación. */
@Injectable({ providedIn: 'root' })
export class ConfirmService {
  constructor(private modals: NgbModal) {}

  ask(opts: ConfirmOptions): Promise<boolean> {
    const ref = this.modals.open(ConfirmDialogComponent, { centered: true, backdrop: 'static' });
    ref.componentInstance.opts = opts;
    return ref.result.then(() => true, () => false);
  }
}
